var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTradesPosition1Image(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 58,
    viewBox: "0 0 60 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1011 16.1126L29.6244 8.32316L46.1476 16.1126L50.2245 33.5984L38.7962 47.627H20.4525L9.02421 33.5984L13.1011 16.1126Z",
    fill: "#CC8CFB",
    fillOpacity: 0.05,
    stroke: "url(#paint0_linear_1820_2170)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9017 9.75044L40.1863 11.0918L50.5152 25.9223L45.1132 43.0659L28.0495 49.6217L12.1683 40.646L9.43624 22.9019L21.9017 9.75044Z",
    fill: "#CC8CFB",
    fillOpacity: 0.05,
    stroke: "url(#paint1_linear_1820_2170)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4679 25.1995V23.3935H30.8419V33.5995H28.8259V25.1995H27.4679Z",
    fill: "#FBD365"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1820_2170",
    x1: 29.6244,
    y1: 7.77039,
    x2: 29.6244,
    y2: 50.2293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0572917,
    stopColor: "#FBD365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#F09336"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1820_2170",
    x1: 40.4676,
    y1: 10.6147,
    x2: 19.4666,
    y2: 47.7727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0572917,
    stopColor: "#FBD365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#F09336"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradesPosition1Image);
export default __webpack_public_path__ + "static/media/TradesPosition1Image.dff4fee2eaf0f259e143ab5fd34ce3cb.svg";
export { ForwardRef as ReactComponent };